import api from './api';

export const authService = {
  async register(data) {
    const response = await api.post('/auth/register', data);
    return response.data;
  },

  async login(data) {
    const response = await api.post('/auth/login', data);
    return response.data;
  },

  // Sign in (or auto-register) with a Google ID token from Google
  // Identity Services. Backend verifies the token's signature against
  // Google's JWKS, looks up or creates the user by verified email, and
  // returns the standard { user, tokens, isNewUser } payload.
  async googleSignIn(idToken) {
    const response = await api.post('/auth/google', { idToken });
    return response.data;
  },

  async refreshToken(refreshToken) {
    const response = await api.post('/auth/refresh', { refreshToken });
    return response.data;
  },

  async getMe() {
    const response = await api.get('/auth/me');
    return response.data;
  },

  async changePassword(data) {
    const response = await api.post('/auth/change-password', data);
    return response.data;
  },

  async forgotPassword(email) {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  async resetPassword(token, newPassword) {
    const response = await api.post('/auth/reset-password', { token, newPassword });
    return response.data;
  },
};

export default authService;
